import { DocumentNode, gql } from '@apollo/client';

// NOTE: 11/08/2022 - I'm setting the limit here to 999.  Currently fetching 25 vaults takes 176ms
// Even if we had 500 vaults the response should be minimal.  This approach is not optimal as we are fetching
// everything without paging, and should eventually be optimized, but it's lower priority currently and shouldn't
// pose a performance issue for the time being.
export function listFarmsOnChainQuery(chainId: number): DocumentNode {
  return gql`
  query listFarms {
    listFarms (limit: 999, filter: {chainId: {eq: ${chainId}}, isLegacy: {eq: false}}) {
      items {
        poolId
        farmPoolId
        farmName
        searchName
        shortLpName
        lpName
        lpAddress
        displayName
        exchange
        isExternal
        isGeneric
        isIchiPool
        isMigrating
        isRetired
        isHidden
        isUpcoming
        isDeposit
        isPosition
        lpPrice
        tvl
        farmTVL
        baseTokenTVL
        totalPoolLP
        weeklyAPY
        monthlyAPY
        yearlyAPY
        dailyAPY
        futureAPY
        launchDate
        chainId
        vaultIRR
        lpDeployer
        strategyBy
        tokens {
          name
          displayName
          fullName
          address
          decimals
          reserve
          price
          isOneToken
          isBaseToken
        }
        farm {
          farmAddress
          farmId
          farmRewardTokenAddress
          farmRewardTokenDecimals
          farmRewardTokenName
        }
        extras {
          externalText
          externalUrl
          externalButton
          tradeUrl
        }
      }
    }
  }
`;
}
